module.exports = "/static/assets/d6b0a87b93bac86032448b70ffc7b6e1.svg";